/** @jsx h */

// compare widget
import { h, render, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';
import getCompareSessionId from '../utils/compareSessionId';
import {
    BASE_ROUTE,
    COMPARISON_LOCAL_STORAGE_NAME,
    URL_PARTNUMBERS_DIVIDER,
} from '../config/consts';

import ComparisonWidget from './components/ComparisonWidget';
import TopPositionBar from './components/TopPositionBar';

import request from '../utils/request';

const elWidgetWrapper = document.createElement('div');
elWidgetWrapper.id = 'comparison-widget';
elWidgetWrapper.classList.add(styles.WidgetContainerWrap);

if (window.APC_C_BAR_IS_DISABLED) {
    elWidgetWrapper.dataset.isHidden = true;
}

/* --------- ComparisonWidget --------- */

/* ----------- App ----------- */

const storage = {
    name: COMPARISON_LOCAL_STORAGE_NAME,
    set: value => {
        localStorage.setItem(COMPARISON_LOCAL_STORAGE_NAME, JSON.stringify(value));
    },
    get: () => {
        try {
            let result = JSON.parse(localStorage.getItem(COMPARISON_LOCAL_STORAGE_NAME));

            if (!(result instanceof Array)) {
                result = [];
            }

            return result;
        } catch (e) {
            return [];
        }
    },
    clear: () => {
        localStorage.setItem(COMPARISON_LOCAL_STORAGE_NAME, JSON.stringify([]));
    },
};

const state = {
    compareSessionId: getCompareSessionId(),
    skus: storage.get(),
    showComparison: storage.get().length > 0,
    skusCount: storage.get().length,
    showTopBar: false,
    stickyAreaHeight: null,
    toggleComparisonBar:
        typeof window.APC_TOGGLE_COMPARISON_BAR === 'boolean'
            ? window.APC_TOGGLE_COMPARISON_BAR
            : true,
    // below is example of translations data
    /* translationsMap: {
        'apc.comparison.clear_list': 'Clear List',
        'apc.comparison.compare_now': 'Compare Now',
        'apc.comparison.products_to_compare': 'Products to compare',
    }, */
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = state;

        const container = document.querySelector('body');

        container.addEventListener('click', ev => {
            if (ev.target.classList.contains('js-form-choice__input_comparison')) {
                this.onCheckboxChange(ev);
            }
        });

        this.getSkusBeforeLoading();

        if (this.state.skusCount > 0) {
            this.checkStorage();
        }

        Object.defineProperty(window, 'APC_TOGGLE_COMPARISON_BAR', {
            get: () => this.state.toggleComparisonBar,
            set: val => {
                this.setState({
                    toggleComparisonBar: val,
                });
            },
            configurable: true,
        });

        const observer = new MutationObserver(this.checkStorage);
        observer.observe(container, { childList: true, subtree: true });
    }

    /**
     * Synchronizes "showComparison" state's property with
     * actual bar visibility through Universal Sticky Container API
     */
    setBarVisibility() {
        const usc = window.APC_USC;

        if (this.state.showComparison && this.state.toggleComparisonBar) {
            usc.show(elWidgetWrapper);
        } else {
            usc.hide(elWidgetWrapper);
        }
    }

    handlePDPHeaderChangeEvent = e => {
        const stickyAreaHeight = e.detail.stickyAreaHeight < 0 ? 0 : e.detail.stickyAreaHeight;
        this.setState({
            stickyAreaHeight,
        });
    };

    componentDidMount() {
        window.addEventListener('storage', this.onStorageEvent);
        const { cc, lc } = this.getLocaleFromURL();
        request
            .get(process.env.API_GET_TRANSLATIONS, {
                params: {
                    translationsMapName: 'comparisonBar',
                    locale: `${lc.toLowerCase()}_${cc.toUpperCase()}`,
                },
            })
            .then(result => {
                this.setState({
                    ...result,
                });
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
            });

        /**
         * PDP_HEADER_CHANGE is a custom event which comes from the
         * PDP code when the page sticky header is replaced by the
         * PDP custom sticky header ( sticky tabs )
         * */
        document.body.addEventListener('PDP_HEADER_CHANGE', this.handlePDPHeaderChangeEvent);
    }

    componentWillUnMount() {
        document.body.removeEventListener('PDP_HEADER_CHANGE', this.handlePDPHeaderChangeEvent);

        window.removeEventListener('storage', this.onStorageEvent);
    }

    componentDidUpdate() {
        if (!window.IS_PDP_PAGE) {
            this.setBarVisibility();
        }
    }

    /*
    * Need to check all checked checkboxes before script is loaded and add them to localstorage
    * after script is loaded.
    * APCG-9381
    */
    getSkusBeforeLoading = () => {
        const { skus } = this.state;
        const checkboxesArr = document.querySelectorAll(
            '.result-list__item-comparison .js-form-choice__input_comparison:checked',
        );

        for (let i = 0; i < checkboxesArr.length; i++) {
            const newSkuId = checkboxesArr[i].dataset.comparisonSku;

            if (!skus.includes(newSkuId)) {
                this.addSkuToComaparison(newSkuId);
            }
        }
    };

    checkStorage = () => {
        if (this.state.skusCount >= 0) {
            const { skus } = this.state;
            const checkboxesArr = document.querySelectorAll(
                '.result-list__item-comparison .js-form-choice__input_comparison',
            );

            for (let i = 0; i < checkboxesArr.length; i++) {
                checkboxesArr[i].checked = skus.includes(checkboxesArr[i].dataset.comparisonSku);
            }
        }
    };

    onCheckboxChange(ev) {
        const inputElement = ev.target;
        const skuId = this.getCheckedSkuId(inputElement);

        if (inputElement.checked) {
            this.addSkuToComaparison(skuId);
            this.setState({ showTopBar: true });

            if (this.tm) {
                clearTimeout(this.tm);
            }
        } else {
            this.removeSkuIdFromComparison(skuId);
            // this.setState({ showTopBar: false });
        }
    }

    getCheckedSkuId(element) {
        return element.dataset.comparisonSku;
    }

    combineStateWithStorage = skus => {
        const currentItems = storage.get();

        /* Need concatenate current value with new, because there is an issue when user click
        * "Compare" checkbox on  different tabs.
        * Bug:[APCG-10288]
        */
        const concatArrays = skus.concat(currentItems);
        const uniqueArr = concatArrays.reduce((acc, itm) => {
            if (acc.indexOf(itm) === -1) {
                acc.push(itm);
            }

            return acc;
        }, []);

        return uniqueArr;
    };

    addSkuToComaparison(newSkuId) {
        const skus = [newSkuId].concat(this.state.skus);
        const combinedItems = this.combineStateWithStorage(skus);
        storage.set(combinedItems);
        this.setState({
            skus: combinedItems,
            showComparison: combinedItems.length > 0,
            skusCount: combinedItems.length,
        });
    }

    removeSkuIdFromComparison(elementToDelete) {
        const skus = this.state.skus.filter(element => element !== elementToDelete);
        storage.set(skus);
        this.setState({
            skus,
            showComparison: skus.length > 0,
            skusCount: skus.length,
        });
    }

    handleCloseComparison = () => () => {
        this.setState({
            showComparison: false,
        });
    };

    clearClickHandler = () => () => {
        storage.clear();
        this.setState(
            {
                skus: [],
                showComparison: false,
                skusCount: 0,
            },
            () => {
                this.checkStorage();
            },
        );
    };

    onStorageEvent = storageEvent => {
        if (storageEvent.key === COMPARISON_LOCAL_STORAGE_NAME) {
            this.setState({
                skus: storage.get(),
                showComparison: storage.get().length > 0,
                skusCount: storage.get().length,
            });
        }
    };
    /**
     * Getting locale information from the URL
     * @returns Object { cc: String, lc: String } ex. { cc: 'us', lc: 'en' }
     */
    getLocaleFromURL() {
        const rx = /\/(?:shop\/)?(\w{2})\/(\w{2})\//i;
        const m = rx.exec(window.location.pathname);

        if (m) {
            return { cc: m[1], lc: m[2] };
        }

        // eslint-disable-next-line no-console
        console.error('Locale data is not found in the URL. Using us-en fallback');

        return { cc: 'us', lc: 'en' };
    }

    getCompareURL() {
        const { cc, lc } = this.getLocaleFromURL();
        const baseUrl = BASE_ROUTE.replace(':cc', cc).replace(':lc', lc);

        return [
            baseUrl,
            this.state.compareSessionId,
            storage.get().join(URL_PARTNUMBERS_DIVIDER),
        ].join('/');
    }

    handleCloseTopBar = () => {
        this.setState({ showTopBar: false });
    };

    renderTopBar() {
        const { showTopBar, stickyAreaHeight, skusCount } = this.state;

        const topBarContainerWrapperClasses = classNames({
            [styles.WidgetContainerWrap]: true,
            [styles.topPosition]: true,
            [styles.hideTopBar]: !showTopBar,
        });

        const topBarContainerClasses = classNames({
            [styles.WidgetContainer]: true,
        });

        const topBarConatinerStyle = {};

        if (stickyAreaHeight) {
            topBarConatinerStyle.top = `${stickyAreaHeight}px`;
            topBarConatinerStyle.position = 'fixed';
        }

        return (
            <div style={topBarConatinerStyle} className={topBarContainerWrapperClasses}>
                <div className={topBarContainerClasses}>
                    <TopPositionBar
                        skusCount={skusCount}
                        compareURL={this.getCompareURL()}
                        handleCloseComparison={this.handleCloseTopBar}
                        translationsMap={this.state.translationsMap}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (window.IS_PDP_PAGE) {
            return this.renderTopBar();
        }

        const { showComparison, skusCount } = this.state;

        const showWidgetClasses = classNames({
            [styles.WidgetContainer]: true,
            [styles.show]: showComparison,
        });

        return (
            <div className={showWidgetClasses}>
                <ComparisonWidget
                    skusCount={skusCount}
                    compareURL={this.getCompareURL()}
                    handleCloseComparison={this.handleCloseComparison()}
                    clearClickHandler={this.clearClickHandler()}
                    translationsMap={this.state.translationsMap}
                />
            </div>
        );
    }
}

App.propTypes = {
    ph: PropTypes.object.isRequired,
};

document.addEventListener('DOMContentLoaded', () => {
    if (window.IS_PDP_PAGE) {
        const container = document.createElement('div');
        document.body.appendChild(container);
        render(<App />, container);
    } else {
        render(<App />, elWidgetWrapper);
        window.APC_USC.add(elWidgetWrapper, { hidden: true });
    }
});
